import { Injectable, WritableSignal, inject, signal } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ApiService } from './api.service';
import { RequestHandlerParams } from './types/api-service.types';
import { ApiResponse } from './common/types';

export interface Territory {
  id: number;
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class TerritoriesService {
  private apiService = inject(ApiService);

  territories: WritableSignal<Territory[]> = signal([]);
  isLoading: WritableSignal<boolean> = signal(false);

  private endpoints = {
    base: '/territories'
  };

  getTerritories(): Observable<ApiResponse<Territory[]>> {
    this.isLoading.set(true);

    const params: RequestHandlerParams = {
      method: 'GET',
      endpoint: this.endpoints.base,
      apiV3: true,
      showErrorMessage: false,
      returnError: true
    };

    return this.apiService.handleRequest<ApiResponse<Territory[]>>(params).pipe(
      tap({
        next: (response: ApiResponse<Territory[]>) => {
          this.territories.set(response?.data ?? []);
          this.isLoading.set(false);
        },
        error: () => this.isLoading.set(false)
      })
    );
  }
}
